import { render } from "./IconExternal.vue?vue&type=template&id=6403b5ca"
const script = {}
script.render = render

export default script